export default function () {
  return {
    byId: {},
    inflight: {},
  };
}
